// Activity Components
import WordMeaningActivity, { validateWordMeaningContent } from './WordMeaningActivity';
import DualMeaningActivity, { validateDualMeaningContent } from './DualMeaningActivity';
import MatchActivity, { validateMatchActivity } from './MatchActivity';
import OppositesActivity, { validateOppositesContent } from './OppositesActivity';
import WhoSaidToWhomActivity, { validateWhoSaidToWhomContent } from './WhoSaidToWhomActivity';
import QuestionAnswersActivity, { validateQuestionAnswersContent } from './QuestionAnswersActivity';
import LongQuestionAnswersActivity, { validateLongQuestionAnswersContent } from './LongQuestionAnswersActivity';
import WordPracticeActivity, { validateWordPracticeContent } from './WordPracticeActivity';
import WordSplitActivity, { validateWordSplitContent } from './WordSplitActivity';
import MakeSentencesActivity, { validateMakeSentencesContent } from './MakeSentencesActivity';
import CreativeWritingActivity, { validateCreativeWritingContent } from './CreativeWritingActivity';
import FillInBlankMcqActivity, { validateFillInBlankMcqContent } from './FillInBlankMcqActivity';
import NumbersActivity, { validateNumbersContent } from './NumbersActivity';
import GendersActivity, { validateGendersContent } from './GendersActivity';
import ChangeGendersActivity, { validateChangeGendersContent } from './ChangeGendersActivity';
import TensesActivity, { validateTensesContent } from './TensesActivity';
import SingularPluralActivity, { validateSingularPluralContent } from './SingularPluralActivity';
import JoinWordsActivity, { validateJoinWordsContent } from './JoinWordsActivity';
import Constants from '../../../utilities/constants/Constants';

// Activity Registry
export const ACTIVITY_COMPONENTS = {
  [Constants.ACTIVITY_TYPES.WORD_MEANING]: WordMeaningActivity,
  [Constants.ACTIVITY_TYPES.DUAL_MEANING]: DualMeaningActivity,
  [Constants.ACTIVITY_TYPES.MATCH]: MatchActivity,
  [Constants.ACTIVITY_TYPES.OPPOSITES]: OppositesActivity,
  [Constants.ACTIVITY_TYPES.WHO_SAID_TO_WHOM]: WhoSaidToWhomActivity,
  [Constants.ACTIVITY_TYPES.QUESTION_ANSWERS]: QuestionAnswersActivity,
  [Constants.ACTIVITY_TYPES.LONG_QUESTION_ANSWERS]: LongQuestionAnswersActivity,
  [Constants.ACTIVITY_TYPES.WORD_PRACTICE]: WordPracticeActivity,
  [Constants.ACTIVITY_TYPES.WORD_SPLIT]: WordSplitActivity,
  [Constants.ACTIVITY_TYPES.MAKE_SENTENCES]: MakeSentencesActivity,
  [Constants.ACTIVITY_TYPES.CREATIVE_WRITING]: CreativeWritingActivity,
  [Constants.ACTIVITY_TYPES.FILL_IN_BLANK_MCQ]: FillInBlankMcqActivity,
  [Constants.ACTIVITY_TYPES.NUMBERS]: NumbersActivity,
  [Constants.ACTIVITY_TYPES.GENDERS]: GendersActivity,
  [Constants.ACTIVITY_TYPES.CHANGE_GENDERS]: ChangeGendersActivity,
  [Constants.ACTIVITY_TYPES.TENSES]: TensesActivity,
  [Constants.ACTIVITY_TYPES.SINGULAR_PLURAL]: SingularPluralActivity,
  [Constants.ACTIVITY_TYPES.JOIN_WORDS]: JoinWordsActivity
};

// Validation Registry
export const ACTIVITY_VALIDATORS = {
  [Constants.ACTIVITY_TYPES.WORD_MEANING]: validateWordMeaningContent,
  [Constants.ACTIVITY_TYPES.DUAL_MEANING]: validateDualMeaningContent,
  [Constants.ACTIVITY_TYPES.MATCH]: validateMatchActivity,
  [Constants.ACTIVITY_TYPES.OPPOSITES]: validateOppositesContent,
  [Constants.ACTIVITY_TYPES.WHO_SAID_TO_WHOM]: validateWhoSaidToWhomContent,
  [Constants.ACTIVITY_TYPES.QUESTION_ANSWERS]: validateQuestionAnswersContent,
  [Constants.ACTIVITY_TYPES.LONG_QUESTION_ANSWERS]: validateLongQuestionAnswersContent,
  [Constants.ACTIVITY_TYPES.WORD_PRACTICE]: validateWordPracticeContent,
  [Constants.ACTIVITY_TYPES.WORD_SPLIT]: validateWordSplitContent,
  [Constants.ACTIVITY_TYPES.MAKE_SENTENCES]: validateMakeSentencesContent,
  [Constants.ACTIVITY_TYPES.CREATIVE_WRITING]: validateCreativeWritingContent,
  [Constants.ACTIVITY_TYPES.FILL_IN_BLANK_MCQ]: validateFillInBlankMcqContent,
  [Constants.ACTIVITY_TYPES.NUMBERS]: validateNumbersContent,
  [Constants.ACTIVITY_TYPES.GENDERS]: validateGendersContent,
  [Constants.ACTIVITY_TYPES.CHANGE_GENDERS]: validateChangeGendersContent,
  [Constants.ACTIVITY_TYPES.TENSES]: validateTensesContent,
  [Constants.ACTIVITY_TYPES.SINGULAR_PLURAL]: validateSingularPluralContent,
  [Constants.ACTIVITY_TYPES.JOIN_WORDS]: validateJoinWordsContent
};

// Helper function to get activity component
export const getActivityComponent = (activityType) => {
  return ACTIVITY_COMPONENTS[activityType] || null;
};

// Helper function to validate activity content
export const validateActivityContent = (activityType, content) => {
  const validator = ACTIVITY_VALIDATORS[activityType];
  if (!validator) {
    return ['Unknown activity type'];
  }
  
  try {
    let parsedContent;
    
    // Handle different content formats
    if (typeof content === 'string') {
      // If it's a string, try to parse it as JSON
      parsedContent = JSON.parse(content);
    } else if (content && typeof content === 'object') {
      // If it's already an object, use it directly
      parsedContent = content;
    } else {
      return ['Invalid content format'];
    }
    
    return validator(parsedContent);
  } catch (error) {
    return ['Invalid JSON content: ' + error.message];
  }
};

// Helper function to get default content for activity type
export const getDefaultContent = (activityType) => {
  return Constants.DEFAULT_CONTENT[activityType] || {};
};
